import { DefaultButton } from '@fluentui/react';
import { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './index.module.sass';
import Auth from "../../Auth/Auth";

interface CartButtonProps {
    cartLines: any[];
}

export default function CartChip(): ReactElement {

    const isUserSuscribed = Auth.isSubscribed();

    function mapStateToProps(state: any) {
        const isUserSuscribedUser = Auth.isSubscribed();

    if(!isUserSuscribedUser){
        return { cartLines: state.educationalCart.cartLines };
    } else {
        return { cartLines: state.cart.cartLines };
    }
    }

    const CartChipChild = connect(mapStateToProps)((props: CartButtonProps) => {

        
        if (props.cartLines?.length === 0) {
            return <></>
        }

        return (
            <div className={styles.CartButtonContainer}>
                <Link to={!isUserSuscribed ? "cart-ef" : '/cart'}>
                    <div>
                        <div className={`${styles.Badge} badge`}>{props.cartLines.length}</div>
                        <DefaultButton title="Carrito">
                            <i className="ironia-icon shopping-cart" />
                        </DefaultButton>
                    </div>
                </Link>
            </div>
        )
    });

    return (
        <CartChipChild />
    )
}